import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar el vacío",
    opening: localizedGenderNode(
      [
      "Hoy no intento llenarlo.",
      "Solo noto el vacío tal como es.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento llenarlo.",
      "Solo noto el vacío tal como es.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se siente más este vacío?",
      "¿Qué pasa justo antes de que aparezca?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se siente más este vacío?",
      "¿Qué pasa justo antes de que aparezca?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar ya es una conexión."
    ],
      [
      "Notar ya es una conexión."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Cómo se ve por fuera",
    opening: localizedGenderNode(
      [
      "Hoy veo la brecha.",
      "Entre lo que se ve en mí y lo que siento.",
      "Solo ver."
    ],
      [
      "Hoy veo la brecha.",
      "Entre lo que se ve en mí y lo que siento.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mis pies."
    ],
      [
      "Respiro despacio.",
      "Siento mis pies."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo se ve mi vida desde fuera?",
      "¿Qué se siente distinto por dentro?",
      "¿Qué me cuesta decir sobre esta brecha?"
    ],
      [
      "¿Cómo se ve mi vida desde fuera?",
      "¿Qué se siente distinto por dentro?",
      "¿Qué me cuesta decir sobre esta brecha?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La brecha no significa que sea falso/a. Significa que no estoy solo/a en esto."
    ],
      [
      "La brecha no significa que sea falso/a. Significa que no estoy solo/a en esto."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre la brecha.",
      "escribir una palabra sobre la brecha."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Cuándo empezó",
    opening: localizedGenderNode(
      [
      "Hoy busco el inicio del vacío.",
      "Sin culpa.",
      "Solo una señal."
    ],
      [
      "Hoy busco el inicio del vacío.",
      "Sin culpa.",
      "Solo una señal."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo lo noté por primera vez?",
      "¿Qué pasaba a mi alrededor entonces?",
      "¿Qué cambió en mí desde entonces?"
    ],
      [
      "¿Cuándo lo noté por primera vez?",
      "¿Qué pasaba a mi alrededor entonces?",
      "¿Qué cambió en mí desde entonces?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A veces un inicio pequeño explica mucho."
    ],
      [
      "A veces un inicio pequeño explica mucho."
    ]
    ),
    action: localizedGenderNode(
      "poner un nombre suave al inicio.",
      "poner un nombre suave al inicio."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Qué me falta",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué me falta de verdad.",
      "No para obtenerlo.",
      "Solo para identificarlo."
    ],
      [
      "Hoy pregunto qué me falta de verdad.",
      "No para obtenerlo.",
      "Solo para identificarlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me falta en estos momentos?",
      "¿Qué necesitaba y no recibí?",
      "¿Qué necesidad pequeña se despierta en mí?"
    ],
      [
      "¿Qué me falta en estos momentos?",
      "¿Qué necesitaba y no recibí?",
      "¿Qué necesidad pequeña se despierta en mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una necesidad pequeña es un inicio de conexión."
    ],
      [
      "Una necesidad pequeña es un inicio de conexión."
    ]
    ),
    action: localizedGenderNode(
      "escribir una necesidad en silencio.",
      "escribir una necesidad en silencio."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Protecciones que trabajan mucho",
    opening: localizedGenderNode(
      [
      "Hoy veo mis protecciones.",
      "Lo que intentan proteger.",
      "Sin juzgar."
    ],
      [
      "Hoy veo mis protecciones.",
      "Lo que intentan proteger.",
      "Sin juzgar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento los hombros."
    ],
      [
      "Me detengo un momento.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi protección principal frente al vacío?",
      "¿De qué intenta protegerme sentir?",
      "¿Cómo afecta mi día?"
    ],
      [
      "¿Cuál es mi protección principal frente al vacío?",
      "¿De qué intenta protegerme sentir?",
      "¿Cómo afecta mi día?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso la protección es una señal de dolor."
    ],
      [
      "Incluso la protección es una señal de dolor."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Momentos de vida",
    opening: localizedGenderNode(
      [
      "Hoy busco momentos de vida.",
      "Aunque sean pequeños.",
      "Aunque sean breves."
    ],
      [
      "Hoy busco momentos de vida.",
      "Aunque sean pequeños.",
      "Aunque sean breves."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Siento las manos."
    ],
      [
      "Respiro.",
      "Siento las manos."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sentí una gota de vida últimamente?",
      "¿Qué había allí que ayudó?",
      "¿Qué puedo invitar un 1% más?"
    ],
      [
      "¿Cuándo sentí una gota de vida últimamente?",
      "¿Qué había allí que ayudó?",
      "¿Qué puedo invitar un 1% más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso una gota de vida cambia la dirección."
    ],
      [
      "Incluso una gota de vida cambia la dirección."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "Entre vacío y cansancio",
    opening: localizedGenderNode(
      [
      "Hoy separo el vacío del cansancio.",
      "Quizá no son lo mismo.",
      "Lo observo."
    ],
      [
      "Hoy separo el vacío del cansancio.",
      "Quizá no son lo mismo.",
      "Lo observo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Estoy cansado/a o vacío/a - o ambos?",
      "¿Qué pide mi cuerpo ahora?",
      "¿Qué le daría si pudiera?"
    ],
      [
      "¿Estoy cansado/a o vacío/a - o ambos?",
      "¿Qué pide mi cuerpo ahora?",
      "¿Qué le daría si pudiera?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El cuerpo a veces sabe antes que la mente."
    ],
      [
      "El cuerpo a veces sabe antes que la mente."
    ]
    ),
    action: localizedGenderNode(
      "escuchar mi cuerpo un minuto.",
      "escuchar mi cuerpo un minuto."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "Palabras que no dije",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que no se dijo.",
      "Eso también es parte del vacío.",
      "Estoy conmigo."
    ],
      [
      "Hoy noto lo que no se dijo.",
      "Eso también es parte del vacío.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento la garganta."
    ],
      [
      "Respiro despacio.",
      "Siento la garganta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué no he dicho en mucho tiempo?",
      "¿A quién quería decirle algo?",
      "¿Qué me diría primero a mí?"
    ],
      [
      "¿Qué no he dicho en mucho tiempo?",
      "¿A quién quería decirle algo?",
      "¿Qué me diría primero a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Las palabras no dichas aún viven en mí."
    ],
      [
      "Las palabras no dichas aún viven en mí."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase que no dije.",
      "escribir una frase que no dije."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "Un límite que protege",
    opening: localizedGenderNode(
      [
      "Hoy busco un límite pequeño que proteja el corazón.",
      "Sin cerrarme.",
      "Solo proteger."
    ],
      [
      "Hoy busco un límite pequeño que proteja el corazón.",
      "Sin cerrarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento el pulso."
    ],
      [
      "Me detengo un momento.",
      "Siento el pulso."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño puede devolver una sensación de mí."
    ],
      [
      "Un límite pequeño puede devolver una sensación de mí."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición para mí.",
      "No grande.",
      "Simple."
    ],
      [
      "Hoy formulo una petición para mí.",
      "No grande.",
      "Simple."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito de verdad ahora?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué necesito de verdad ahora?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede abrir una puerta."
    ],
      [
      "Una petición puede abrir una puerta."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "Una cosa pequeña que nutre",
    opening: localizedGenderNode(
      [
      "Hoy busco una cosa pequeña que me nutra.",
      "No para cambiar.",
      "Solo para volver."
    ],
      [
      "Hoy busco una cosa pequeña que me nutra.",
      "No para cambiar.",
      "Solo para volver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento el abdomen."
    ],
      [
      "Me detengo un momento.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me nutre aunque sea un poco?",
      "¿Cuándo lo hice por última vez?",
      "¿Cómo puedo invitarlo hoy?"
    ],
      [
      "¿Qué me nutre aunque sea un poco?",
      "¿Cuándo lo hice por última vez?",
      "¿Cómo puedo invitarlo hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Algo pequeño puede recordarme que estoy vivo/a."
    ],
      [
      "Algo pequeño puede recordarme que estoy vivo/a."
    ]
    ),
    action: localizedGenderNode(
      "elegir una cosa pequeña que nutra.",
      "elegir una cosa pequeña que nutra."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "Sentarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy me siento conmigo un momento.",
      "Sin necesidad de hacer.",
      "Solo estar."
    ],
      [
      "Hoy me siento conmigo un momento.",
      "Sin necesidad de hacer.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Noto el silencio."
    ],
      [
      "Respiro despacio.",
      "Noto el silencio."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasa en mí cuando solo me siento?",
      "¿Qué es lo más difícil para mí en este silencio?",
      "¿Qué me suaviza aunque sea un poco?"
    ],
      [
      "¿Qué pasa en mí cuando solo me siento?",
      "¿Qué es lo más difícil para mí en este silencio?",
      "¿Qué me suaviza aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar conmigo un momento ya es un cambio pequeño."
    ],
      [
      "Estar conmigo un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "un minuto sentado/a con una respiración.",
      "un minuto sentado/a con una respiración."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "Una frase suave para mí",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase suave.",
      "No grande.",
      "Solo una verdad pequeña."
    ],
      [
      "Hoy elijo una frase suave.",
      "No grande.",
      "Solo una verdad pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me gustaría escuchar ahora?",
      "¿Cómo suena cuando me lo dicen?",
      "¿Puedo decírmelo a mí?"
    ],
      [
      "¿Qué me gustaría escuchar ahora?",
      "¿Cómo suena cuando me lo dicen?",
      "¿Puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una frase suave puede ser una cuerda de rescate."
    ],
      [
      "Una frase suave puede ser una cuerda de rescate."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase una vez.",
      "decir la frase una vez."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la presencia.",
      "Cuando me siento vacío/a.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la presencia.",
      "Cuando me siento vacío/a.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre este vacío?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre este vacío?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo encontrar el vacío y respirar dentro de él."
    ],
      [
      "Puedo encontrar el vacío y respirar dentro de él."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const everythingIsFineOnPaperButInsideIsEmptyBlueprintEs = buildNormalizedPilotBlueprint({
  id: "everything_is_fine_on_paper_but_inside_is_empty_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "everything_is_fine_on_paper_but_inside_is_empty",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "הכול בסדר על הנייר - ובפנים ריק",
    en: "Everything is fine on paper - but inside is empty",
    es: "Todo está bien en el papel, pero por dentro está vacío",
  },
  days,
});

export default everythingIsFineOnPaperButInsideIsEmptyBlueprintEs;
